import { createAction } from '@reduxjs/toolkit';

export const membershipUpdateId = createAction('membership/updateId');
export const membershipUpdateUID = createAction('membership/updateUid');
export const membershipUpdateSID = createAction('membership/updateSid');
export const membershipUpdateIsAdded = createAction('membership/updateIsAdded');
export const membershipUpdateIsActive = createAction('membership/updateIsActive');

export const membershipStore = createAction('membership/store');
export const membershipClear = createAction('membership/clear');

export const membershipUpdateRequesting = createAction('membership/updateRequesting');
export const membershipUpdateRequest = createAction('membership/updateRequest');
export const membershipUpdateError = createAction('membership/updateError');
export const membershipUpdateStore = createAction('membership/updateStore');

export const membershipUpdateHeadingTitle = createAction('membership/updateHeadingTitle');
export const membershipUpdateHeadingDescription = createAction('membership/updateHeadingDescription');
export const membershipUpdateHeadingTextAlign = createAction('membership/updateHeadingTextAlign');
export const membershipUpdateHeadingImage = createAction('membership/updateHeadingImage');
export const membershipUpdateHeadingDivider = createAction('membership/updateHeadingDivider');

export const membershipUpdateSectionIsBackground = createAction('membership/updateSectionIsBackground');
export const membershipUpdateSectionTextColor = createAction('membership/updateSectionTextColor');
export const membershipUpdateSectionBackgroundColor = createAction('membership/updateSectionBackgroundColor');
export const membershipUpdateSectionOpacity = createAction('membership/updateSectionOpacity');
export const membershipUpdateSectionIsFullWidth = createAction('membership/updateSectionIsFullWidth');
export const membershipUpdateSectionShadow = createAction('membership/updateSectionShadow');
export const membershipUpdateSectionShadowColor = createAction('membership/updateSectionShadowColor');
export const membershipUpdateSectionPadding = createAction('membership/updateSectionPadding');
export const membershipUpdateSectionMargin = createAction('membership/updateSectionMargin');
export const membershipUpdateSectionBackgroundType = createAction('membership/updateSectionBackgroundType');
export const membershipUpdateSectionBackgroundImage = createAction('membership/updateSectionBackgroundImage');
export const membershipUpdateSectionGradientColor1 = createAction('membership/updateSectionGradientColor1');
export const membershipUpdateSectionGradientColor2 = createAction('membership/updateSectionGradientColor2');
export const membershipUpdateSectionGradientDirection = createAction('membership/updateSectionGradientDirection');
export const membershipUpdateSectionGradientOffset = createAction('membership/updateSectionGradientOffset');
export const membershipUpdateSectionBorder = createAction('membership/updateSectionBorder');
export const membershipUpdateSectionBorderColor = createAction('membership/updateSectionBorderColor');
export const membershipUpdateSectionShadowBorderColor = createAction('membership/updateSectionShadowBorderColor');
export const membershipUpdateSectionShape = createAction('membership/updateSectionShape');

export const membershipUpdateItemShadow = createAction('membership/updateItemShadow');
export const membershipUpdateItemShadowColor = createAction('membership/updateItemShadowColor');
export const membershipUpdateItemBorder = createAction('membership/updateItemBorder');
export const membershipUpdateItemBorderColor = createAction('membership/updateItemBorderColor');
export const membershipUpdateItemShape = createAction('membership/updateItemShape');
export const membershipUpdateItemTextColor = createAction('membership/updateItemTextColor');
export const membershipUpdateItemBackgroundColor = createAction('membership/updateItemBackgroundColor');

export const membershipUpdateItems = createAction('membership/updateItems');
export const membershipUpdateView = createAction('membership/updateView');
